export default "\n<app-qr-code [value]=\"printString\" [size]=\"500\" ></app-qr-code>\n<p>\n  {{label}}\n</p>\n";